import React from "react"

export default (props) => <code {...props} className="language-text" />